import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Page, DatePicker } from 'ui/components';

import { Journal } from 'services/action';

import Table from './component/table.config';
import { formatDate } from 'utilities/common';

const initialState = {
  data: null,
  periode: {
    default: new Date(),
    formatted: formatDate(new Date(), 'YYYY-MM'),
  },
};

const ProfitAndLossScreen = () => {
  const Dispatch = useDispatch();
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Journal.GetProfitAndLoss']
  );

  const [{ data, periode }, setState] =
    React.useState(initialState);

  const $onLoad = async() => {
    let data = null
    const result = await Dispatch(Journal.$getProfitAndLoss({periode: periode?.formatted}));

    if (result?.message === 'success') {
      data = result?.data
    }

    setState((prevState) => ({...prevState, data: data}));
  }

  React.useEffect(() => {
    $onLoad();
  }, [periode]);

  return (
    <Page className="fixed ">
      <Page.Header
        pretitle="Daftar"
        title={'Laba Rugi'}
        isLoading={StateLoading}
      />

      <div className='row bg-white px-2 m-0'>
        <div className='col-12'>
          <div className='px-3'>
            <div className="d-flex table-tools align-items-center justify-content-end">
              <div className="d-flex align-items-center">
                <div className="mb-3">
                  <label class="form-label fs-8">Pilih Periode</label>
                  <DatePicker
                    selectionMode="month"
                    value={periode?.default || null}
                    format="yyyy/MM"
                    onChange={(e) => {
                      setState((prevState) => ({...prevState, periode: { default: e, formatted: formatDate(e, 'YYYY-MM') }}))
                    }}
                    isShowTrigger
                  />
                </div>

                {/* <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip id={`tooltip-top`}>Download XLS</Tooltip>}
                >
                  <Button
                    variant="dark"
                    className="ms-2"
                    onClick={$handleDownload}
                    style={{ height: 30 }}
                  >
                    <HiOutlineCloudDownload size={18} color="white" />
                  </Button>
                </OverlayTrigger> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Page.Body className="row border-top">
        <Table data={data} />
      </Page.Body>
    </Page>
  );
};

export default ProfitAndLossScreen;